// Main.js file.
// IIFE - Immediately Invoked Function Expression
(function (yourcode) {
    // The global jQuery object is passed as a parameter
    yourcode(window.jQuery, window, document);
}(function ($, window, document) {
    // The $ is now locally scoped
    // Listen for the jQuery ready event on the document
    $(function () {
        // The DOM is ready!

        // Redirect to page after Voting
        $('.post-ratings img').click(function() {
            $.ajax({  
                url: 'arets-varsta-sloseri-2018', 
                success: function(data){
                  window.location.href = "tack-for-din-rost";                    
                }
            });
        });



        //GDPR
        jQuery(".join-our-network-wrapper input[type='submit']").addClass("disable-btn");
        jQuery(".join-our-network-wrapper .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".join-our-network-wrapper .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".join-our-network-wrapper input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".join-our-network-wrapper input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });
        jQuery(".section-support input[type='submit']").addClass("disable-btn");
        jQuery(".section-support .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".section-support .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".section-support input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".section-support input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });
        jQuery(".sidebar-newsletter input[type='submit']").addClass("disable-btn");
        jQuery(".sidebar-newsletter .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".sidebar-newsletter .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".sidebar-newsletter input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".sidebar-newsletter input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });
        jQuery(".footer-inner input[type='submit']").addClass("disable-btn");
        jQuery(".footer-inner .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".footer-inner .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".footer-inner input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".footer-inner input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });
        jQuery(".bli-medlem-subpage-register-right input[type='submit']").addClass("disable-btn");
        jQuery(".bli-medlem-subpage-register-right .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".bli-medlem-subpage-register-right .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".bli-medlem-subpage-register-right input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".bli-medlem-subpage-register-right input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });

        jQuery(".wpcf7-form input[type='submit']").addClass("disable-btn");
        jQuery(".wpcf7-form .gdpr input[type='checkbox']").on("change", function () {

            if (jQuery(".wpcf7-form .gdpr input[type='checkbox']").is(':checked')) {
                jQuery(".wpcf7-form input[type='submit']").removeClass("disable-btn");
            } else {
                jQuery(".wpcf7-form input[type='submit']").addClass("disable-btn");
                // jQuery(".order-radondosa-button").addClass("disable");

            }
        });

        // ---------------- Sticky header when scroll down-------------- //

        $('.header').removeClass("header--is-sticky");

        // Hero background position on some pages
        if ($('.hero-background-image').length) {
            var image_url;
            image_url = $('.section-hero').css('background-image');
            var image;
            $('.hero-background-image').css('background-image', image_url);
            $('.section-hero').removeAttr('style');
            image_url = image_url.match(/^url\("?(.+?)"?\)$/);
            // image = new Image();
            // image.src = image_url;
            if (image_url != null) {
                image_url = image_url[1];
                image = new Image();
                image.src = image_url;

                // just in case it is not already loaded
                $(image).load(function () {
                    if (!($('body').hasClass('page-id-50') || $('body').hasClass('parent-pageid-50'))) {
                        if (!$('.hero-bottom').length) {
                            $('.hero-wrapper').height(image.height - 79);
                        } else {
                            $('.hero-wrapper').height(image.height + 40);
                        }
                    }
                    $('.hero-background-image').height(image.height + 40);
                });

            }

        }

        // Sidebar info
        var image_info = new Image();
        image_info.src = $('.sidebar-info img').attr("src");
        // alert('width: ' + image_info.naturalWidth + ' and height: ' + image_info.naturalHeight);
        $(image_info).load(function () {
            $('.sidebar-info').css('height', image_info.naturalHeight + 'px');

        });


        var TaxMaxHeight = 0;
        $('.page-template-page-bli-medlem .taxpay-reasons-desc .taxpay-reason-single').each(function () {

            if ($(this).height() > TaxMaxHeight) {
                TaxMaxHeight = $(this).height();
            }

        });
        $('.page-template-page-bli-medlem .taxpay-reasons-desc .taxpay-reason-single').height(TaxMaxHeight);

        if ($('.section-campaign').length) {
            var image_url;
            image_url = $('.section-campaign').css('background-image');
            var image;
            image_url = image_url.match(/^url\("?(.+?)"?\)$/);
            // image = new Image();
            // image.src = image_url;
            if (image_url != null) {
                image_url = image_url[1];
                image = new Image();
                image.src = image_url;

                // just in case it is not already loaded
                $(image).load(function () {
                    $('.background-overlay').css('min-height', image.height);
                    // $('.hero-background-image').height(image.height);
                });

            }

        }

        $(window).scroll(function () {
            if ($(this).scrollTop() > 10) {
                $('.header').addClass("header--is-sticky");
                $('.container--1440').css('margin-top', '70px');
            }
            else {

                $('.header').removeClass("header--is-sticky");
                $('.container--1440').css('margin-top', '0px');
            }
        });


//
//     if($('.hero-background-image').length){
//       var image_url = $('.hero-background-image').css('background-image'),
//           image;
//
// // Remove url() or in case of Chrome url("")
//       image_url = image_url.match(/^url\("?(.+?)"?\)$/);
//
//       if (image_url[1]) {
//         image_url = image_url[1];
//         image = new Image();
//
//         // just in case it is not already loaded
//         $(image).load(function () {
//           $('.hero-wrapper').height(image.height);
//           $('.hero-background-image').height(image.height);
//         });
//
//         image.src = image_url;
//       }
//
//     }

        // Tax calculator toggle
        $('.resultat-inner > *').css('margin', '0px');
        $('.tax-calc-wrapper').each(function () {
            var parent_this = $(this);
            parent_this.find('form input[type="submit"]').click(function () {
                parent_this.find('.resultat-inner').slideDown(500);
                parent_this.find('.toggle-result').addClass('rotate-arrow');
            });
            parent_this.find('.toggle-result').click(function () {
                parent_this.find('.resultat-inner').slideToggle(500);
                $(this).toggleClass('rotate-arrow');
            });
        });


        // Hover primary menu

        $('.header-navigation .menu-primary >li').hover(function () {
            $(this).children('ul').stop(true, false, true).fadeToggle(300);
        });

        $('.header-navigation .menu-primary >li').hover(function () {
            $('.header-navigation .menu-primary >li a').removeClass('is-hovered');
            $(this).children('a').addClass('is-hovered');

        }, function () {
            $('.header-navigation .menu-primary >li a').removeClass('is-hovered');

        });

        // Hover search header

        $('.header-search a').click(function (e) {
            e.preventDefault();
            $('.header-search-form').fadeToggle('fast');

        });

        // Youtube player hero

        // Youtube id
        var video_id = $('.hero-video').attr('data-video-id');

        function getArtistId() {


            return video_id;
        }


        function loadPlayer() {
            if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                window.onYouTubePlayerAPIReady = function () {
                    onYouTubePlayer();
                };
            }
            else {
                onYouTubePlayer();
            }
        }

        var player;

        function onYouTubePlayer() {
            player = new YT.Player('player', {
                height: '0',
                width: '0',
                videoId: getArtistId(),
                playerVars: {
                    autoplay: 1,        // Auto-play the video on load
                    controls: 1,       // Show pause/play buttons in player
                    showinfo: 0,        // Hide the video title
                    modestbranding: 1,  // Hide the Youtube Logo
                    loop: 1,            // Run the video in a loop
                    fs: 0,              // Hide the full screen button
                    cc_load_policy: 0, // Hide closed captions
                    autohide: 0,         // Hide video controls when playing
                    rel: 0,             // Hide related video
                    iv_load_policy: 3  // Hide the Video Annotations
                },
                events: {
                    'onStateChange': onPlayerStateChange,
                    'onError': catchError,
                    'onReady': function (e) {
                        e.target.mute();
                    }
                }
            });
        }

        var done = false;

        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING && !done) {
                done = true;
            }
            else if (event.data == YT.PlayerState.ENDED) {
                exitPlayer();
                player.loadVideoById(video_id);
                $('.video-foreground').css({'height': '300%', 'top': '-100%'});
                $('.video-background').css({'height': '500px'});
                $('body').css('overflow', 'auto');

            }
        }

        function catchError(event) {
            if (event.data == 100) {
                console.log("Error");
            }
        }

        function stopVideo() {
            player.stopVideo();
        }

        // Handle video in background and video in full screeen
        // On play-video click - show video in full screen, with sound and controls

        $('.play-video').click(function () {
            $('.overlay').hide();
            $('.hero-video .container').hide();
            $('.video-foreground').css({'height': '100%', 'top': 0});
            $('.video-background').css({'height': '100%'});
            player.unMute();
            player.loadVideoById(video_id);
            // $('body').css('overflow', 'hidden');
            $('.exit-player').show();
        });

        // On exit-player click - hide full screen and revert to first state
        $('.exit-player').click(function () {
            $('.video-foreground').css({'height': '300%', 'top': '-100%'});
            $('.video-background').css({'height': '500px'});
            $('body').css('overflow', 'auto');

            exitPlayer();

        });

        function exitPlayer() {
            $('.overlay').show();
            $('.hero-video .container').show();
            player.mute();
            // player.loadVideoById('qP_0zpdcx_M');
            $('.exit-player').hide();
        }

        // Swish info height
        // var swish_info_height = $('.swish-info').style.height;
        // $('.swish-image').height(swish_info_height);

        // Custom scroll bar

        function scroll(parent) {

            var container = parent.find('.scrollbar-container');
            var content = parent.find('.scroll-content');
            var scroll = parent.find('.scrollbar');

            content.scroll(function () {
                var elem_height = container.height() * content.height() / content.prop('scrollHeight');
                var elem_top = container.height() * content.scrollTop() / content.prop('scrollHeight');
                scroll.height(elem_height);
                scroll.css('top', elem_top);
            });
            var event = new Event('scroll');
            content.mousedown(function (start) {
                start.preventDefault();
                var y = scroll.offset().top;
                var onMove = function (end) {
                    var delta = end.pageY - start.pageY;
                    var scroll_top = Math.min(container.height() - scroll.height(), Math.max(0, y + delta));
                    scroll.scrollTop(scroll_top);
                    var content_scroll_top = (content.prop('scrollHeight') * scroll.offset().top / container.height());
                    content.scrollTop(content_scroll_top);
                };
                document.addEventListener('mousemove', onMove);
                document.addEventListener('mouseup', function () {
                    document.removeEventListener('mousemove', onMove);
                });
            });
        }


        // Open/Close Popup
        function getScrollHeight(parent) {

            var container = parent.find('.scrollbar-container');
            var content = parent.find('.scroll-content');
            var scroll = parent.find('.scrollbar');

            var elem_height = container.height() * content.height() / content.prop('scrollHeight') + "px";
            scroll.height(elem_height);


        }


        $('.support-open-popup').click(function (e) {
            e.preventDefault();
            var popup = $(this).closest('section').find('.support-popup-wrapper');
            $(popup).fadeIn(700);
            var this_parent = $(this).closest('section');

            getScrollHeight(this_parent);
            scroll(this_parent);

        });
        $('.support-short-open-popup').click(function (e) {
            e.preventDefault();
            var popup = $(this).closest('section').find('.support-popup-wrapper');
            $(popup).fadeIn(700);
            var this_parent = $(this).closest('section');

            getScrollHeight(this_parent);
            scroll(this_parent);


        });
        $('.form-open-popup').click(function (e) {
            e.preventDefault();
            var popup = $(this).closest('section').find('.support-popup-wrapper');
            $(popup).fadeIn(700);
            var this_parent = $(this).closest('section');

            getScrollHeight(this_parent);
            scroll(this_parent);


        });
        $('.close-popup').click(function (e) {
            e.preventDefault();
            var popup = $(this).closest('section').find('.support-popup-wrapper');
            $(popup).fadeOut(700);
        });

        // Q&A
        $('.question-answer-single .question').click(function (e) {
            e.preventDefault();
            var slideDown = $(this).parent().find('.answer');
            $(".question-answer-single .question").not(this).parent().find('.answer').slideUp();
            $(".question-answer-single .question").not(this).removeClass('question-plus');
            $(".question-answer-single .question span").not(this).html('+');
            slideDown.slideToggle();
            $(this).toggleClass('question-plus');
            $('.question-plus span').html('-');


        });

        if (!$('.hero-bottom').length) {
            $('.hero-wrapper').addClass('hero-bottom-none');
        }
        //
        // // Init carosel
        $(".regular").slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });


        // Change numer in carosel
        // var slick_num = $('.section-taxpay-reasons .slick-dots .slick-active
        // button').text(); console.log(slick_num); $('.taxpay-reasons-number
        // span').text(slick_num);

        $('.regular').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            $('.taxpay-reasons-number span').text(nextSlide + 1);
            $('.taxpay-reasons-number span').addClass(' slideInUp');
        });

        // On after slide change
        $('.regular').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('.taxpay-reasons-number span').removeClass(' slideInUp');

        });

        // Animate to support
        $(".swish-bli-supporter").click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#skatte-support").offset().top - 36
            }, 2000);
        });

        // Animate to support

        $(".section-support-choices .choice-wrapper:nth-of-type(3) .choice-item").click(function (e) {
            var choice_item_link = $('.section-support-choices .choice-wrapper:nth-of-type(3) .choice-item').attr('href');
            // console.log(choice_item_link);
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(choice_item_link).offset().top - 36
            }, 2000);
        });
        // Animate to support
        $(".section-support-choices .choice-wrapper:nth-of-type(4) .choice-item").click(function (e) {
            var choice_item_link = $('.section-support-choices .choice-wrapper:nth-of-type(4) .choice-item').attr('href');
            // console.log(choice_item_link);
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(choice_item_link).offset().top - 36
            }, 2000);
        })


        if ($('.sidebar-advertise-wrapper').css('background-image') != 'none') {
            $('.sidebar-advertise-background').addClass('background-overlay-show');
        }

        $('.bli-medlem-single--blue .button-arrow--white').hover(function () {
            $(this).addClass('is-hovered-bli-medlem');
            $('.bli-medlem-single--blue h4').addClass('is-hovered-bli-medlem');

        }, function () {
            $(this).removeClass('is-hovered-bli-medlem');
            $('.bli-medlem-single--blue h4').removeClass('is-hovered-bli-medlem');

        });

        if ($(window).width() > 1023) {
            var listPerson = $('.team-wrapper .team-single-person');

            for (var i = 0; i < listPerson.length; i += 4) {
                listPerson.slice(i, i + 4).wrapAll('<div class="single-person-wrapper"></div>');
            }
        }


        // Devide list on 2 half

        var listItemsPrivate = $('.bli-medlem-subpage-benefits-wrapper ul li').length;
        var listItemsFacts = $('.campaign-facts-wrapper ul li').length;
        var list_half = listItemsPrivate / 2;
        var list_half_facts = listItemsFacts / 2 + 1;

        var list_left = $('.bli-medlem-subpage-benefits-wrapper ul li').slice(0, list_half);
        var list_right = $('.bli-medlem-subpage-benefits-wrapper ul li').slice(list_half);

        var list_left_facts = $('.campaign-facts-wrapper ul li').slice(0, list_half_facts);
        var list_right_facts = $('.campaign-facts-wrapper ul li').slice(list_half_facts);


        list_left.wrapAll('<div class="list-left"></div>');
        list_right.wrapAll('<div class="list-right"></div>');

        list_left_facts.wrapAll('<div class="list-left"></div>');
        list_right_facts.wrapAll('<div class="list-right"></div>');


        // Smooth scroll of Social share icons
        // var $scrollingDiv = $(".fixed-socials-share");
        //
        // $(window).scroll(function () {
        //     $scrollingDiv
        //         .stop()
        //         .animate({"marginTop": ($(window).scrollTop()) + "px"}, "slow");
        // });


        // Mobile menu
        $('.open-menu').click(function () {
            $('#responsive-menu-container').addClass('open');
            $('body').css('overflow', 'hidden');
        });
        $('.close-menu').click(function () {
            $('#responsive-menu-container').removeClass('open');
            $('body').css('overflow', 'scroll');


        });
        // Add .last-item class
        $('.campaign-items-section').last().addClass('last-item');

// Set waves background on campaign single page
//         var campaign_items = $('.campaign-items-section');
//         campaign_items.wrapAll('<section class="section-waves-vertical large-waves"></section>');
        // Progress button

        $('.progress-button').attr("data-style", "fill");

        $(document).ajaxStop(function () {

            $('.progress-button .progress-inner').hide();
            // $('.progress-button .content').parent().remove();

            [].slice.call(document.querySelectorAll('button.progress-button')).forEach(function (bttn) {
                new ProgressButton(bttn, {
                    callback: function (instance) {
                        var progress = 0,
                            interval = setInterval(function () {
                                progress = Math.min(progress + Math.random() * 0.1, 1);
                                instance._setProgress(progress);

                                if (progress === 1) {
                                    instance._stop(1);
                                    clearInterval(interval);
                                }
                            }, 10);
                    }
                });
            });
        });
        $('select').material_select();

        // $('input[type="range"]').on('mouseout touchleave', function () {
        //     $('.thumb').fadeOut();
        // });
        // $('input[type="range"]').mouseenter(function () {
        //   $('.thumb').fadeIn();
        // });


        var wrapper_items1 = $(".skatte-single-news-wrapper");
        var wrapper_items2 = $(".section-latest-news");

        if (wrapper_items1.is('[data-num-items]')) {
            var number_of_items = wrapper_items1.attr("data-num-items");


            if (number_of_items < 7) {
                $('.upload-more-wrapper button').addClass('is-disabled');
            }
        }
        if (wrapper_items2.is('[data-num-items]')) {
            var number_of_items2 = wrapper_items2.attr("data-num-items");


            if (number_of_items2 < 7) {
                $('.upload-more-wrapper button').addClass('is-disabled');
            }
        }

        $(".join-our-network-wrapper form tr").each(function () {

            var remove_text_form = $(this).find('td');
            var text_placeholder = remove_text_form.contents().filter(function () {
                return this.nodeType === 3;
            });
            $(this).find('input').attr('placeholder', text_placeholder.text());

            // var newText = $(this).text().replace(/def/g, "");
            // $(this).text(newText);
        });

        $(".bli-medlem-subpage-register-right form tr").each(function () {

            var remove_text_form = $(this).find('td');
            var text_placeholder = remove_text_form.contents().filter(function () {
                return this.nodeType === 3;
            });
            $(this).find('input').attr('placeholder', text_placeholder.text());

            // var newText = $(this).text().replace(/def/g, "");
            // $(this).text(newText);
        });

        $(".footer-inner form tr").each(function () {

            var remove_text_form = $(this).find('td');
            var text_placeholder = remove_text_form.contents().filter(function () {
                return this.nodeType === 3;
            });
            $(this).find('input').attr('placeholder', text_placeholder.text());

            // var newText = $(this).text().replace(/def/g, "");
            // $(this).text(newText);
        });
        $(".sidebar-newsletter form tr").each(function () {

            var remove_text_form = $(this).find('td');
            var text_placeholder = remove_text_form.contents().filter(function () {
                return this.nodeType === 3;
            });
            $(this).find('input').attr('placeholder', text_placeholder.text());

            // var newText = $(this).text().replace(/def/g, "");
            // $(this).text(newText);
        });

        $(".support-form-wrapper form tr").each(function () {

            var remove_text_form = $(this).find('td');
            var text_placeholder = remove_text_form.contents().filter(function () {
                return this.nodeType === 3;
            });
            $(this).find('input').attr('placeholder', text_placeholder.text());

            // var newText = $(this).text().replace(/def/g, "");
            // $(this).text(newText);
        });

        $(".support-form-wrapper").each(function () {
            var support_form = $(this).find('form');
            var contents = support_form.find("td, th").contents().detach();
            support_form.find("table").remove();
            support_form.append(contents);
            support_form.contents().filter(function () {
                return this.nodeType === 3;
            }).remove();
        });
        $(".bli-medlem-subpage-register-right").each(function () {
            var support_form = $(this).find('form');
            var contents = support_form.find("td, th").contents().detach();
            support_form.find("table").remove();
            support_form.append(contents);
            support_form.contents().filter(function () {
                return this.nodeType === 3;
            }).remove();
        });

        // var support_form = $(".support-form-wrapper form");
        //
        var footer_form = $(".footer-inner form");
        var sidebar_form = $(".sidebar-newsletter form");
        var join_netwotk_form = $(".join-our-network-wrapper form");
        var bli_medlem_subpage_form = $(".bli-medlem-subpage-register-right form");
        // var contents = support_form.find("td, th").contents().detach();
        var contents_footer = footer_form.find("td, th").contents().detach();
        var contents_network = join_netwotk_form.find("td, th").contents().detach();
        var contents_sidebar = sidebar_form.find("td, th").contents().detach();
        var contents_bli_medlem = bli_medlem_subpage_form.find("td, th").contents().detach();
        // support_form.find("table").remove();
        // support_form.append(contents);
        //
        //
        //
        // support_form.contents().filter(function () {
        //     return this.nodeType === 3;
        // }).remove();
        //
        // console.log('test');
        footer_form.find("table").remove();
        sidebar_form.find("table").remove();
        bli_medlem_subpage_form.find("table").remove();
        //
        footer_form.append(contents_footer);
        sidebar_form.append(contents_sidebar);
        join_netwotk_form.append(contents_network);
        bli_medlem_subpage_form.append(contents_bli_medlem);

        footer_form.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();

        join_netwotk_form.find("table").remove();
        join_netwotk_form.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();
        sidebar_form.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();
        bli_medlem_subpage_form.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();


        $(window).load(function () {
            [].slice.call(document.querySelectorAll('button.progress-button')).forEach(function (bttn) {
                new ProgressButton(bttn, {
                    callback: function (instance) {
                        var progress = 0,
                            interval = setInterval(function () {
                                progress = Math.min(progress + Math.random() * 0.1, 1);
                                instance._setProgress(progress);

                                if (progress === 1) {
                                    instance._stop(1);
                                    clearInterval(interval);
                                }
                            }, 10);
                    }
                });
            });
            loadPlayer();

            // // Get an array of all element heights
            if ($(window).width() > 767) {
                var choice_items_list = $('.page-template-page-medlemskap-formaner .section-choises .choice-wrapper');

                for (var i = 0; i < choice_items_list.length; i += 3) {
                    var wrapped_list = choice_items_list.slice(i, i + 3);
                    wrapped_list.wrapAll("<div class='functions-items-wrapper'></div>");
                }
                $('.page-template-page-medlemskap-formaner .section-choises .choice-wrapper').each(function () {
                    var choice_item_height = $(this).find('.choice-item--decs').outerHeight(true);
                    // $(this).find(':nth-child(2)').css('clear', 'both');

                    if (120 < choice_item_height) {
                        $(this).find('.choice-see-more-text').show();
                    }
                    else {
                        $(this).find('.choice-see-more-text').hide();
                    }
                    //
                    if (!$(this).find('.choice-see-more-text').is(':visible')) {
                        $(this).find('.choice-item--more').css('position', 'absolute').css('bottom', '-30px');
                    }

                });


                $('.choice-see-more-text').toggle(function () {

                    var toggleHeight = $(this).closest('.choice-wrapper').find('.choice-item--decs').outerHeight(true);
                    $(this).find('p').text('VISA MINDRE');
                    $(this).css('box-shadow', 'none');
                    // $('.choice-item--more').css('bottom', '-30px');
                    // var autoHeight =  choice_wrapper.height();
                    // console.log(autoHeight)

                    // $(this).closest('.choice-wrapper').animate({
                    //      height: autoHeight,
                    //  }, 500);

                    $(this).parent().find('.choice-item-wrapper--decs').animate({
                        height: toggleHeight + 50,
                    }, 500)
                    $(this).closest('.choice-wrapper').css('height', 'auto');

                    // $(this).parent().animate({
                    //     height: toggleHeight + 210,
                    // }, 500)
                }, function () {
                    $(this).find('p').text('LÄS MER');
                    $(this).css('box-shadow', '3px -2px 22px 7px rgba(255, 255, 255, 0.9)');
                    // $('.choice-item--more').css('bottom', '-30px');
                    $(this).closest('.choice-wrapper').animate({
                        height: 440,
                    }, 500);


                    $(this).parent().find('.choice-item-wrapper--decs').animate({
                        height: 120,
                    }, 500)

                    // $(this).parent().animate({
                    //     height: 370,
                    // }, 500)
                });

                if($('.single-campaign p').html() == '') {
                    $(this).hide();
                }
                if($('.single-campaign ul').html() == '') {
                    $(this).hide();

                }

                // var elementHeights = $('.section-choises .choice-item--decs').map(function () {
                //     return $(this).height();
                // }).get();
                // // console.log(elementHeights);
                // // Math.max takes a variable number of arguments
                // // // `apply` is equivalent to passing each height as an argument
                // var maxHeight = Math.max.apply(null, elementHeights);
                // //
                // // // Set each height to the max height
                // $('.section-choises .choice-item--decs').height(maxHeight);
            }
        });
    });
}));




